/* Crew Ready single items (Evan, 2026-09-17): the price per piece drops at 24, 48 and 100 pieces. Each order-size tier is its
   own variant ("8 to 23", "24 to 47", ...). When a buyer changes a single-item quantity in the cart (typing, + or -) into
   another tier, this moves the line to that tier's variant with the same line item properties (company, logo file, color,
   sizes, notes), so the price always matches the quantity. Cart lines opt in with data-crew-tiers='[{"min":8,"id":123},...]'
   (sections/main-cart-items.liquid, snippets/cart-drawer.liquid). Every other line goes through Dawn untouched. */
(function () {
  if (typeof CartItems === 'undefined' || CartItems.prototype.__crewTiers) return;
  CartItems.prototype.__crewTiers = true;
  var dawnUpdate = CartItems.prototype.updateQuantity;
  // The move in flight, shared by the cart page and the drawer (they edit the same cart). While it runs the cart's
  // row order changes (Shopify puts the added line first), so no row-numbered Dawn update may go out.
  var busy = null;

  function url(name, fallback) {
    var r = window.routes && window.routes[name];
    return (r || fallback) + '.js';
  }
  function json(u, body) {
    var opts = { headers: { Accept: 'application/json' } };
    if (body) { opts.method = 'POST'; opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    return fetch(u, opts).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || (data && data.status && data.status >= 400)) throw new Error((data && (data.description || data.message)) || r.status);
        return data;
      });
    });
  }
  function tierFor(tiers, n) {
    var pick = null;
    tiers.forEach(function (t) { if (n >= t.min && (!pick || t.min > pick.min)) pick = t; });
    return pick;
  }
  function tiersOf(input) {
    try { return input && input.dataset.crewTiers ? JSON.parse(input.dataset.crewTiers) : null; } catch (e) { return null; }
  }
  function errorText() {
    return (window.cartStrings && window.cartStrings.error) || 'There was an error. Please try again.';
  }

  // Puts cart line `key` at quantity q on the variant of q's tier. Resolves { cart, key } with the line's key afterwards.
  // Keys, not row numbers, so it is safe while rows move.
  function move(key, tiers, q, depth) {
    return json(url('cart_url', '/cart')).then(function (cart) {
      var item = cart.items.filter(function (i) { return i.key === key; })[0];
      if (!item) return { cart: cart, key: null };
      var tier = tierFor(tiers, q);
      if (!tier || String(tier.id) === String(item.variant_id)) {
        if (item.quantity === q) return { cart: cart, key: key };
        return json(url('cart_change_url', '/cart/change'), { id: key, quantity: q }).then(function (c) { return { cart: c, key: key }; });
      }
      return json(url('cart_add_url', '/cart/add'), { items: [{ id: tier.id, quantity: q, properties: item.properties || {} }] })
        .then(function (added) {
          var line = added.items[0];
          return json(url('cart_change_url', '/cart/change'), { id: key, quantity: 0 })
            .catch(function (err) {
              // The old line is still in the cart: take the added pieces back out so nothing is in it twice.
              return json(url('cart_change_url', '/cart/change'), { id: line.key, quantity: line.quantity - q })
                .then(function () { throw err; }, function () { throw err; });
            })
            .then(function (c) {
              // Shopify merged the pieces into a line that was already on that tier variant: the merged total can belong to a higher tier.
              if (line.quantity !== q && (depth || 0) < 3) {
                var t2 = tierFor(tiers, line.quantity);
                if (t2 && String(t2.id) !== String(line.variant_id)) return move(line.key, tiers, line.quantity, (depth || 0) + 1);
              }
              return { cart: c, key: line.key };
            });
        });
    });
  }

  // Repaints the cart, drawer, totals and bubble through Dawn with a no-change update of one line, then shows `message` on it.
  function repaint(self, cart, event, name, key, message) {
    if (!cart.items.length) { window.location.reload(); return; }
    var idx = 0;
    cart.items.forEach(function (i, k) { if (i.key === key) idx = k; });
    var line = idx + 1, qty = cart.items[idx].quantity;
    // Dawn compares its answer with the box that sits at this row number BEFORE it repaints (a different line once rows
    // moved), and would show "You can only add N of this item". Give that box the answer.
    var box = document.getElementById('Quantity-' + line) || document.getElementById('Drawer-quantity-' + line);
    if (box) { box.value = qty; box.dataset.quantityLineKey = cart.items[idx].key; }
    if (message && typeof subscribe === 'function') {
      var off = subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        off();
        var el = document.getElementById('Line-item-error-' + line) || document.getElementById('CartDrawer-LineItemError-' + line);
        if (el && el.querySelector('.cart-item__error-text')) el.querySelector('.cart-item__error-text').textContent = message;
      });
    }
    dawnUpdate.call(self, line, qty, event, name, cart.items[idx].variant_id);
  }

  CartItems.prototype.updateQuantity = function (line, quantity, event, name, variantId) {
    var self = this, args = arguments;
    var input = this.querySelector('#Quantity-' + line) || this.querySelector('#Drawer-quantity-' + line);
    if (busy) {
      if (input) input.value = input.getAttribute('value');
      return;
    }
    var tiers = tiersOf(input);
    var q = parseInt(quantity, 10);
    if (!tiers || !tiers.length || !(q > 0)) return dawnUpdate.apply(this, args);
    var tier = tierFor(tiers, q);
    if (!tier || String(tier.id) === String(input.dataset.quantityVariantId)) return dawnUpdate.apply(this, args);

    var key = input.dataset.quantityLineKey;
    this.enableLoading(line);
    var run = move(key, tiers, q);
    busy = run;
    run.then(function (r) {
      busy = null;
      repaint(self, r.cart, event, name, r.key);
    }, function () {
      return json(url('cart_url', '/cart')).then(function (cart) {
        busy = null;
        repaint(self, cart, event, name, key, errorText());
      }, function () { busy = null; window.location.reload(); });
    });
  };

  // A line can sit on the wrong tier without anyone typing in the cart: carts from before the tiers existed (24+ pieces on
  // the old variant, now the lowest tier), or an add that Shopify merged into a line with the same properties. Fix those
  // when a cart shows up (page load, drawer re-render after an add). Lines that failed once are left alone.
  var failedKeys = {};
  function reconcile() {
    if (busy) return;
    var todo = [];
    Array.prototype.forEach.call(document.querySelectorAll('input.quantity__input[data-crew-tiers]'), function (i) {
      var t = tiersOf(i), q = parseInt(i.getAttribute('value'), 10), tier = t && q > 0 ? tierFor(t, q) : null, key = i.dataset.quantityLineKey;
      if (!tier || String(tier.id) === String(i.dataset.quantityVariantId) || failedKeys[key]) return;
      if (todo.some(function (x) { return x.key === key; })) return;
      todo.push({ key: key, tiers: t, q: q, host: i.closest('cart-items, cart-drawer-items') });
    });
    if (!todo.length || !todo[0].host) return;
    var last = null;
    var run = todo.reduce(function (p, w) {
      return p.then(function () { return move(w.key, w.tiers, w.q).then(function (r) { last = r; }, function () { failedKeys[w.key] = true; }); });
    }, Promise.resolve());
    busy = run;
    run.then(function () { return json(url('cart_url', '/cart')); }).then(function (cart) {
      busy = null;
      // on /cart the drawer is rendered too: repaint through the cart page when it is there, so the page shows the new tier
      repaint(document.querySelector('cart-items') || todo[0].host, cart, { currentTarget: null }, null, last && last.key);
    }, function () { busy = null; });
  }
  if (typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) { if (!e || e.source !== 'cart-items') setTimeout(reconcile, 0); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reconcile); else setTimeout(reconcile, 0);

  // Check out (and Enter in a quantity box) posts the cart form with updates[] quantities matched to rows by POSITION,
  // before the debounced change above runs. A typed quantity that crosses a tier would go to checkout on the old tier's
  // price, and a move still running would reorder the rows under it. Apply every typed quantity by line key first
  // (moving tier lines), then submit without updates[].
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement) || (form.id !== 'cart' && form.id !== 'CartDrawer-Form')) return;
    if (form.__crewPass) { form.__crewPass = false; return; }
    var inputs = Array.prototype.slice.call(form.querySelectorAll('input.quantity__input[data-quantity-line-key]'));
    var crosses = inputs.some(function (i) {
      var t = tiersOf(i), q = parseInt(i.value, 10), tier = t && q > 0 ? tierFor(t, q) : null;
      return tier && String(tier.id) !== String(i.dataset.quantityVariantId);
    });
    if (!busy && !crosses) return;
    e.preventDefault();
    var submitter = e.submitter;
    if (submitter) submitter.setAttribute('aria-disabled', 'true');
    var wanted = inputs.map(function (i) { return { key: i.dataset.quantityLineKey, q: parseInt(i.value, 10), tiers: tiersOf(i) }; });
    var start = busy ? busy.then(function () {}, function () {}) : Promise.resolve();
    var run = start.then(function () {
      return wanted.reduce(function (p, w) {
        return p.then(function () {
          if (!(w.q >= 0)) return;
          if (w.tiers && w.q > 0) return move(w.key, w.tiers, w.q);
          return json(url('cart_url', '/cart')).then(function (cart) {
            var it = cart.items.filter(function (i) { return i.key === w.key; })[0];
            if (it && it.quantity !== w.q) return json(url('cart_change_url', '/cart/change'), { id: w.key, quantity: w.q });
          });
        });
      }, Promise.resolve());
    });
    busy = run;
    run.then(function () {
      busy = null;
      // a repaint during the sync replaces the drawer's form and buttons: submit the ones on the page now
      var f = document.getElementById(form.id) || form;
      var sub = submitter && submitter.id ? document.getElementById(submitter.id) : null;
      Array.prototype.forEach.call(f.querySelectorAll('input[name="updates[]"]'), function (i) { i.removeAttribute('name'); });
      f.__crewPass = true;
      if (f.requestSubmit) f.requestSubmit(sub && sub.form === f ? sub : undefined);
      else f.submit();
    }, function () {
      busy = null;
      window.location.reload();
    });
  }, true);
})();
